// *********************************
// CoolGames Builder JavaScript file
// *********************************
/**
 * Converts a number in milliseconds to an object representing hours, minutes and seconds.
 * @param {number} ms the time in milliseconds.
 * @returns {Object} an object with hours, minutes and seconds represented as numbers.
 */
export function msToTime(ms) {
    //create a new dateobject, disregarding the users timezone.
    // 1- Convert to seconds:
    var seconds = Math.ceil(ms / 1000.0);
    // 2- Extract hours:
    var hours = Math.floor(seconds / 3600.0); // 3,600 seconds in 1 hour
    seconds = seconds - (hours * 3600); // seconds remaining after extracting hours
    // 3- Extract minutes:
    var minutes = Math.floor(seconds / 60.0); // 60 seconds in 1 minute
    // 4- Keep only seconds not extracted to minutes:
    seconds = Math.floor(seconds - (minutes * 60.0));
    var time = {
        hours: hours,
        minutes: minutes,
        seconds: seconds
    };
    return time;
}
;
/**
 * Pads a number and returns a string with leading zeros.
 * @param {Number} num the number to display.
 * @param {Number} size the total number of integers in the string, including the leading zeros
 */
export function leadingZeros(num, size) {
    var s = num + "";
    while (s.length < size)
        s = "0" + s;
    return s;
}
